import React from 'react';
import withRipple from 'jd-library/withRipple';

const EditImageButton = props => {
	return (
		<span className={`edit-icon-wrapper ${props.rippleClass}`} {...props.rippleHandler}
			onClick={props.onClick}
		>
			<i className={`font-16 edit-icon icon-cameraNew`} />
			{props.renderRipple()}
		</span>
	);
};

export default withRipple(EditImageButton);
